import APIDriver from './api/APIDriver'
const api = new APIDriver('contests')

const methods = {
    showActive: () => {
        api.setBearerProtection();
        return api.get('active');
    },
    activate: (id) => {
        api.setBearerProtection();
        return api.patch('activate', id);
    },
    get: (id) => {
        api.setBearerProtection();
        return api.get('', id);
    },
    list: () => {
        api.setBearerProtection();
        return api.getAll('');
    },
    create: (data) => {
        api.setBearerProtection();
        return api.post('', data);
    },
    update: (id, data) => {
        api.setBearerProtection();
        return api.patch('', id, data);
    },
    remove: (id) => {
        api.setBearerProtection();
        return api.delete('', id);
    },
    clone: (target_id, source_id) => {
        api.setBearerProtection();
        return api.post('clone_configuration', {
            target_id: target_id,
            source_id: source_id
        });
    }
}


export default methods;